<template>
  <permissions-view
    :site="site"
    :section="section"
  >
    <v-container>
      <loader v-if="loading"></loader>
      <v-form v-model="valid">
        <v-row>
          <v-col cols="3">
            <display-field
              v-if="canView(section, 'site_id')"
              label="Site id"
            >{{ site.site_id }}</display-field>
          </v-col>
          <v-col cols="3">
            <display-field
              v-if="canView(section, 'site_candidate')"
              label="Candidate"
            >{{ site.candidate|noDataAvailable }}</display-field>
          </v-col>
          <v-col cols="3">
            <display-field
              v-if="canView(section, 'site_candidate')"
              label="Site name"
            >{{ site.site_name|noDataAvailable }}</display-field>
          </v-col>
          <v-col cols="3">
            <display-field
              v-if="canView(section, 'site_candidate')"
              label="Active candidate"
            >{{ site.candidate|noDataAvailable }}</display-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <display-field
              v-if="canView(section, 'site_candidate')"
              label="Status"
            >{{ site.status|noDataAvailable }}</display-field>
          </v-col>
          <v-col cols="3">
            <display-field
              v-if="canView(section, 'site_candidate')"
              label="Site onair date"
            >{{ site.location.site_onair_date|formatDate|noDataAvailable}}</display-field>
          </v-col>
          <v-col cols="3">
            <display-field label="Indoor/Outdoor type">Data not available</display-field>
          </v-col>
          <v-col cols="3">
            <display-field label="Building type">Data not available</display-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <display-field label="Site type">{{ site.type|noDataAvailable }}</display-field>
          </v-col>
          <v-col cols="3">
            <display-field label="Counterparts">Data not available</display-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <switch-button
              label="Key tube"
              :readonly="isReadOnly()"
              :value="getValue(access, 'key_tube')"
              @change="setValue(access, 'key_tube', $event)"
            ></switch-button>
          </v-col>
          <v-col>
            <s-textarea
              :readonly="isReadOnly()"
              :value="getValue(access, 'key_tube_location')"
              @input="setValue(access, 'key_tube_location', $event)"
              label="Key tube location"
              filled
            ></s-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <s-textarea
              label="Access to equipment"
              :readonly="isReadOnly()"
              :value="getValue(access, 'access_to_equipment')"
              @input="setValue(access, 'access_to_equipment', $event)"
            />
          </v-col>
          <v-col cols="6">
            <s-textarea
              label="Access to antennas"
              :readonly="isReadOnly()"
              :value="getValue(access, 'access_to_antennas')"
              @input="setValue(access, 'access_to_antennas', $event)"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <text-field
              :readonly="isReadOnly()"
              :value="getValue(access, 'entrance_time_working_days')"
              @input="setValue(access, 'entrance_time_working_days', $event)"
              label="Entrance time (working days)"
            ></text-field>
          </v-col>
          <v-col cols="3">
            <site-access-risk-working-time
              :readonly="isReadOnly()"
              label="Site access risk (working time)"
              :value="getValue(access, 'site_access_risk_working_time')"
              @input="setValue(access, 'site_access_risk_working_time', $event)"
            ></site-access-risk-working-time>
          </v-col>
          <v-col cols="3">
            <text-field
              :readonly="isReadOnly()"
              label="Entrance time (non-working days)"
              :value="getValue(access, 'entrance_time_non_working_days')"
              @input="setValue(access, 'entrance_time_non_working_days', $event)"
            ></text-field>
          </v-col>
          <v-col cols="3">
            <site-access-risk-non-working-time
              :readonly="isReadOnly()"
              label="Site access risk (non-working time)"
              :value="getValue(access, 'site_access_risk_non_working_time')"
              @input="setValue(access, 'site_access_risk_non_working_time', $event)"
            ></site-access-risk-non-working-time>
          </v-col>
        </v-row>
        <s-textarea
          :readonly="isReadOnly()"
          label="Entrance comment"
          :value="getValue(access, 'entrance_comment')"
          @input="setValue(access, 'entrance_comment', $event)"
        />
        <v-row>
          <v-col cols="3">
            <switch-button
              :readonly="isReadOnly()"
              label="Announcement"
              :value="getValue(access, 'announcement')"
              @change="setValue(access, 'announcement', $event)"
            >
            </switch-button>
          </v-col>
          <v-col
            cols="3"
            v-if="getValue(access, 'announcement')"
          >
            <text-field
              :readonly="isReadOnly()"
              label="Announcement days"
              :value="getValue(access, 'announcement_days')"
              @input="setValue(access, 'announcement_days', $event)"
            ></text-field>
          </v-col>
          <v-col
            v-if="getValue(access, 'announcement')"
          >
            <s-textarea
              :readonly="isReadOnly()"
              label="Announcement comments"
              :value="getValue(access, 'announcement_comments')"
              @input="setValue(access, 'announcement_comments', $event)"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <text-field
              :readonly="isReadOnly()"
              label="Generator usage time"
              :value="getValue(access, 'generator_usage_time')"
              @input="setValue(access, 'generator_usage_time', $event)"
            ></text-field>
          </v-col>
          <v-col cols="3">
            <s-textarea
              :readonly="isReadOnly()"
              label="Generator usage comment"
              :value="getValue(access, 'generator_usage_comment')"
              @input="setValue(access, 'generator_usage_comment', $event)"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <display-field label="Easting HTRS96">Data not available</display-field>
          </v-col>
          <v-col cols="3">
            <display-field label="Northing HTRS96">Data not available</display-field>
          </v-col>
          <v-col cols="3">
            <display-field label="Latitude WGS84">{{ site.latitude|formatCoordinates|noDataAvailable }}</display-field>
          </v-col>
          <v-col cols="3">
            <display-field label="Longitude WGS84">{{ site.longitude|formatCoordinates|noDataAvailable }}</display-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <display-field label="Address">{{ site.address|noDataAvailable }}</display-field>
          </v-col>
          <v-col cols="3">
            <display-field label="Town">{{ site.city|noDataAvailable }}</display-field>
          </v-col>
          <v-col cols="3">
            <display-field label="County">{{ site.city|noDataAvailable }}</display-field>
          </v-col>
          <v-col cols="3">
            <display-field label="Municipality">{{ site.municipality|noDataAvailable }}</display-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <display-field label="Land registry">{{ contract.land_registry|noDataAvailable }}</display-field>
          </v-col>
          <v-col cols="3">
            <display-field label="Cadastral parcel">{{ contract.cadastral_parcel|noDataAvailable }}</display-field>
          </v-col>
          <v-col cols="3">
            <display-field label="Cadastral municipality">{{ contract.cadastral_municipality|noDataAvailable }}</display-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <access-contact
              :readonly="isReadOnly()"
              label="Access contact"
              :value="getValue(access, 'announcement_comments')"
              @input="setValue(access, 'announcement_comments', $event)"
            ></access-contact>
            <display-field
              label="HUB site"
            >
              <div
                v-bind:class="{ hub: transmission.hub_site_name === 'Yes'}"
              >
                {{ transmission.hub_site_name }}
              </div>
            </display-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <h2>Documents</h2>
            <file-upload
              :readonly="isReadOnly()"
              module="access"
              :site_id="site.site_id"
              :item_id="site.id"
              :multi="true"
              label="Attachment"
            >
            </file-upload>
          </v-col>
        </v-row>
        <form-actions
          v-if="!isReadOnly()"
          v-on:saveData="saveData"
          :saved="saved"
        ></form-actions>
      </v-form>
    </v-container>
  </permissions-view>
</template>

<script>
  import DisplayField from '@/components/DisplayField'
  import SiteAccessService from '@/services/site-access'
  import ReactivitMixin from '@/mixins/Reactivity'
  import PermissionsMixin from '@/mixins/Permissions'
  import SwitchButton from '@/components/SwitchButton'
  import FormActions from '@/components/FormActions'
  import TextField from '@/components/TextField'
  import STextarea from '@/components/Textarea'
  import SiteAccessRiskWorkingTime from '@/components/codelist/SiteAccessRiskWorkingTime'
  import SiteAccessRiskNonWorkingTime from '@/components/codelist/SiteAccessRiskNonWorkingTime'
  import AccessContact from '@/components/codelist/AccessContact'
  import FileUpload from '@/components/FileUpload'
  import PermissionsView from '@/components/PermissionsView'
  import SiteContractService from '@/services/site-contract'
  import Loader from '@/components/Loader'
  import SiteTransmissionService from '@/services/site-transmission'
  export default {
    name: 'Access',
    mixins: [
      ReactivitMixin,
      PermissionsMixin,
    ],
    components: { Loader, PermissionsView, FileUpload, AccessContact, SiteAccessRiskNonWorkingTime, SiteAccessRiskWorkingTime, STextarea, TextField, FormActions, SwitchButton, DisplayField },
    props: {
      site: {
        default: null,
      },
      active: {
        default: false,
      },
    },
    data () {
      return {
        saved: false,
        valid: false,
        access: null,
        contract: null,
        loading: false,
        transmission: undefined,
        section: 'access',
      }
    },
    watch: {
      active: function (newValue, oldValue) {
        if (newValue === true && oldValue === false) {
          this.fetchData()
        }
      },
    },
    mounted () {
      this.fetchData()
    },
    methods: {
      fetchData () {
        this.loading = true
        const ls = new SiteAccessService(this.site.id)
        ls.getSingle().then((response) => {
          this.access = response.data.data
          if (Array.isArray(this.access)) {
            this.access = {}
          }
          this.fetchContractData().finally(() => {
            this.fetchTransmissionData().finally(() => {
              this.loading = false
            })
          })
        })
      },
      fetchContractData () {
        const scs = new SiteContractService(this.site.id)
        return scs.getSingle().then((response) => {
          this.contract = response.data.data
          if (Array.isArray(this.contract)) {
            this.contract = {}
          }
        })
      },
      fetchTransmissionData () {
        const sts = new SiteTransmissionService(this.site.id)
        return sts.getSingle().then((response) => {
          this.transmission = response.data.data
        })
      },
      saveData () {
        this.saved = false
        if (this.valid) {
          const ls = new SiteAccessService(this.site.id)
          ls.post(this.access).then((response) => {
            this.saved = true
          })
        }
      },
    },
  }
</script>

<style scoped>

.hub {
  color: white;
  font-weight: bold;
  border-radius: 5px;
  background-color: red;
  padding: 10px 1px 10px 1px;
  text-align: center;
}

</style>
